import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ImportContext } from 'providers/ImportStatus';
import { Button as MButton } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { customToolbarButtonTheme } from 'assets/styles/themes/generic_button_mui';
import ImportModalTelepac from '../Exploitation/modal/importModalTelepac';
import ImportModalApia from '../Exploitation/modal/importModalApia';
import ImportModalCSV from '../Exploitation/modal/ImportModalCSV';
import ImportModalGeofolia from '../Exploitation/modal/importModalGeofolia';
import { IMPORT_FROM, IMPORT_TYPE } from 'utils/GlobalVariables';

//! any API call inside this component will create an infinte loop of API calls in procedureCampaign
const ImportButtonListAndModal = ({ locationRoute, from, mappingFiles, nextForecastCampaign }) => {
  const navigate = useNavigate();
  const exploitationId = localStorage.getItem('exploitation');
  const canImportWiuz = mappingFiles?.includes(IMPORT_TYPE.wiuz);
  const canImportGeofolia = mappingFiles?.includes(IMPORT_TYPE.geofolia);
  const canImportTelepac =
    mappingFiles?.includes(IMPORT_TYPE.telepac) &&
    exploitationId &&
    locationRoute === 'exploitation';
  const canImportApia =
    mappingFiles?.includes(IMPORT_TYPE.apia) &&
    exploitationId &&
    locationRoute === 'exploitation';
  const { setImportConfig, nextCampaignChosen, setGeofoliaImportSteps } = useContext(ImportContext);
  const { t } = useTranslation();
  const [isOpenImportModalTelepac, setIsOpenImportModalTelepac] = useState(false);
  const [isOpenImportModalApia, setIsOpenImportModalApia] = useState(false);
  const [isOpenImportModalCSV, setIsOpenImportModalCSV] = useState(false);
  const [isOpenImportModalGeofolia, setIsOpenImportModalGeofolia] = useState(false);

  useEffect(() => {
    //* start : setter used for change code exploit workflow
    setImportConfig({
      importFrom: from,
      importOriginLocation: locationRoute,
      nextCampaignChosen: nextForecastCampaign || null,
    });
  }, []);

  const handleImportTypeAndModalOpen = (importType) => {
    setImportConfig({ importType: importType });
    switch (importType) {
      case IMPORT_TYPE.csv:
        setIsOpenImportModalCSV(true);
        break;
      case IMPORT_TYPE.telepac:
        setIsOpenImportModalTelepac(true);
        break;
      case IMPORT_TYPE.apia:
        setIsOpenImportModalApia(true);
        break;
      case IMPORT_TYPE.geofolia:
        setGeofoliaImportSteps(0);
        setIsOpenImportModalGeofolia(true);
        break;
      default:
        break;
    }
  };

  return (
    <ThemeProvider theme={customToolbarButtonTheme}>
      <MButton onClick={() => handleImportTypeAndModalOpen(IMPORT_TYPE.csv)}>{t('button.importCSV')}</MButton>
      {canImportWiuz && (
        <MButton
          onClick={() => {
            setImportConfig({ importType: IMPORT_TYPE.wiuz });
            navigate(`/${locationRoute}/import/exploitation`, {
              state: {
                from: from,
                ...(nextCampaignChosen != null && { nextCampaignChosen }),
                ...(exploitationId != null && { procedureExploitation: exploitationId }),
              },
            });
          }}
        >
          {t('button.importWiuz')}
        </MButton>
      )}
      {canImportGeofolia && (
        <MButton onClick={() => handleImportTypeAndModalOpen(IMPORT_TYPE.geofolia)}>
          {t('button.importGeofolia')}
        </MButton>
      )}
      {canImportTelepac && (
        <MButton onClick={() => handleImportTypeAndModalOpen(IMPORT_TYPE.telepac)}>
          {t('button.importTelepac')}
        </MButton>
      )}
      {canImportApia && (
        <MButton onClick={() => handleImportTypeAndModalOpen(IMPORT_TYPE.apia)}>
          {t('button.importApia')}
        </MButton>
      )}
      {isOpenImportModalCSV && (
        <ImportModalCSV
          open={isOpenImportModalCSV}
          setModalOpen={setIsOpenImportModalCSV}
          {...(nextCampaignChosen && { nextCampaignChosen })}
          from={from}
        />
      )}
      {isOpenImportModalGeofolia && (
        <ImportModalGeofolia
          open={isOpenImportModalGeofolia}
          setModalOpen={setIsOpenImportModalGeofolia}
          {...(nextCampaignChosen && { nextCampaignChosen })}
          from={from}
        />
      )}
      {isOpenImportModalTelepac && (
        <ImportModalTelepac
          open={isOpenImportModalTelepac}
          setModalOpen={setIsOpenImportModalTelepac}
          {...(nextCampaignChosen && { nextCampaignChosen })}
          from={from}
        />
      )}
      {isOpenImportModalApia && (
        <ImportModalApia
          open={isOpenImportModalApia}
          setModalOpen={setIsOpenImportModalApia}
          {...(nextCampaignChosen && { nextCampaignChosen })}
          from={from}
        />
      )}
    </ThemeProvider>
  );
};

export default ImportButtonListAndModal;
